import { HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import {
  AccountUser,
  CreateIssueRequest,
  IssueDescriptionRequest,
  IssueDescriptionResponse,
  IssueIdName,
} from '../model/issue.model'

@Injectable({
  providedIn: 'root',
})
export abstract class ReconInsightService {
  abstract createReconInsightIssue(
    createIssueRequest: CreateIssueRequest,
  ): Observable<number>

  abstract addAttachment(
    issueId: number,
    attachmentName: string,
    file: File,
  ): Observable<HttpResponse<void>>

  abstract getReconInsightIssueTypes(): Observable<IssueIdName[]>

  abstract getReconInsightIssueSources(): Observable<IssueIdName[]>

  abstract getReconInsightIssuePriorities(): Observable<IssueIdName[]>

  abstract getReconInsightAccountUsers(
    accountId: number,
  ): Observable<AccountUser[]>

  abstract getReconInsightIssueDescription(
    request: IssueDescriptionRequest,
  ): Observable<IssueDescriptionResponse>
}
